import repository from 'client/repository';
import progressActions from 'areas/progress/actions';
import alertActions from 'areas/alert/actions';
import swipeConstants from '../constants';
import m from 'messages';

export function uploadRequested(swipe) {
    return { type: swipeConstants.UPLOAD_SWIPE_REQUESTED, swipe };
}

export function uploadSuccess(swipe) {
    return { type: swipeConstants.UPLOAD_SWIPE_SUCCESS, swipe };
}

export function uploadFailure(e) {
    return { type: swipeConstants.UPLOAD_SWIPE_FAILURE, e };
}

export function setCurrentSwipeContext(context) {
    return { type: swipeConstants.SET_CURRENT_SWIPE_CONTEXT, context };
}

export function storeCurrentUIState(timeToWork, timeFromWork, selectedEmployer, selectedJobRole) {
    return { type: swipeConstants.STORE_SWIPE_UI_STATE, timeToWork, timeFromWork, selectedEmployer, selectedJobRole };
}

export function resetCurrentUIState() {
    return { type: swipeConstants.RESET_SWIPE_UI_STATE };
}

export function clear() {
    return { type: swipeConstants.CLEAR_SWIPES };
}

export function uploadSwipe(swipe) {
    return async dispatch => {
        try {
            dispatch(progressActions.report(m.swipes.uploadingSwipe));
            dispatch(uploadRequested(swipe));

            const response = await repository.swipes.uploadSwipe(swipe);

            if (response.success) {
                dispatch(progressActions.hide());
                dispatch(uploadSuccess(swipe));
            } else {
                dispatch(uploadFailure(response));
                dispatch(alertActions.error(m.swipes.uploadFailure + response.message));
            }
        } catch (e) {
            dispatch(alertActions.error(e.toString()));
        }

        dispatch(progressActions.hide());
    };
}

export function clearSwipes() {
    return { type: swipeConstants.CLEAR_SWIPES };
}